import DataAccess from './constants';

const path = 'token/'

const apiAuthentication = () => {
   const url = DataAccess.apiUrl + path + '?username=' + DataAccess.userName + '&password=' + DataAccess.password;
   fetch(url)
      .then(response => response.json)
      .then((result) => {
         return result.token;
      }
         , (error) => {
            throw new Error(error);
         });
}

export default apiAuthentication;
